import { Container, Spinner, Row, Col } from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroller';
import { useEffect, useState } from 'react';
import '../categoryPage/categoryPage.css';
import ProductCard from '../../components/productCard';
import ComparePanel from '../../components/comparePanel';
import Constants from '../../helpers/Constants';
import { useSearchParams } from 'react-router-dom';
import apiService from '../../services/ApiService';
import { Category, Criteria } from '../../models/category';
import { Product } from '../../models/product';

const SearchPage = () => {
  window.localStorage.setItem('currentCategoryID', '');
  window.localStorage.setItem('subCurrentCategoryID', '');
  window.localStorage.setItem('thirdCurrentCategoryID', '');
  const [isLoading, setIsLoading] = useState(true);
  const [isPaging, setIsPaging] = useState(false);
  const [categoryData, setCategoryData] = useState<Category>({
    items: [],
    itemCount: 0,
    pageCount: 0,
    id: '',
    name: '',
    filter: {
      attributes: [],
    },
    sortings: {},
  });

  const [searchParams] = useSearchParams();
  const keyword = searchParams.get('q');

  const initialCriteria: Criteria = {
    attributes: {},
    sorting: '0',
    page: 1,
    inStockOnly: false,
    keyword: '',
    id: '',
  };
  const [criteria, setCriteria] = useState<Criteria>(initialCriteria);
  const [selectedProducts, setSelectedProducts] = useState<Product[]>([]);

  const getSearchResult = (params: any, isLoading: boolean, categoryData: Category) => {
    setIsPaging(true);
    apiService.get(Constants.ApiPath.ProductSearch, params).then((result) => {
      if (result) {
        let data: Category = {
          items: categoryData.items.concat(result.data.products),
          itemCount: result.data.itemCount,
          pageCount: result.data.pageCount,
          id: '',
          name: result.data.name,
          filter: categoryData.filter,
          sortings: categoryData.sortings,
        };
        if (isLoading) {
          data.sortings = result.data.sortings;
          data.filter.attributes = result.data.attributes ?? [];
        }

        if (params.page === 1) {
          data.items = result.data.products;
        }

        setCategoryData(data);
        setIsLoading(false);
        setIsPaging(false);
      }
    });
  };

  useEffect(() => {
    setIsLoading(true);
    setIsPaging(true);
    setSelectedProducts([]);
    const filter: Criteria = { ...initialCriteria, keyword: keyword! };
    setCriteria(filter);
  }, [keyword]);

  useEffect(() => {
    if (!criteria.keyword) {
      return;
    }
    var params: any = {
      sorting: criteria.sorting,
      page: criteria.page,
      keyword: criteria.keyword,
    };
    Object.keys(criteria.attributes).forEach((name, i) => {
      if (criteria.attributes[name].length > 0) {
        params = {
          ...params,
          [`attributes[${i}].key`]: name,
          [`attributes[${i}].value`]: criteria.attributes[name],
        };
      }
    });
    getSearchResult(params, isLoading, categoryData);
  }, [criteria]);

  const handleCompareCheckboxChange = (event: any) => {
    const id = event.target.value;
    const product = categoryData.items.filter((p) => p.sku === id)[0];
    const products: Product[] = event.target.checked
      ? [...selectedProducts, product]
      : selectedProducts.filter((p) => p.sku !== id);
    if (products.length > Constants.MaxProductsCompared) {
      event.target.checked = false;
      return;
    }
    setSelectedProducts(products);
  };

  const handleClearSelectedProducts = () => {
    setSelectedProducts([]);
  };

  const handleUnSelectProduct = (sku: string) => {
    setSelectedProducts((products) => products.filter((p) => p.sku !== sku));
  };

  const handleLoadMore = () => {
    if (isPaging) {
      return;
    }
    setCriteria((prevData) => {
      return {
        ...prevData,
        page: prevData.page + 1,
      };
    });
  };

  const loader = (
    <Container className="category-page-infinite-loading" key="category-page-loading">
      <Spinner animation="border" />
      <p>Loading...</p>
    </Container>
  );

  return isLoading ? (
    <Container className="category-page-loading" key="category-page-loading">
      <div>
        <Spinner animation="border" />
        <p>Loading...</p>
      </div>
    </Container>
  ) : (
    <>
      <Container fluid>
        <Row>
          <Col>
            <InfiniteScroll
              initialLoad={false}
              loadMore={handleLoadMore}
              hasMore={criteria.page < categoryData.pageCount}
              loader={loader}
            >
              <section id="category-page-lower" className="product-cards-container">
                {categoryData.items.map((model: Product) => {
                  const selected =
                    selectedProducts.findIndex((product) => product.sku === model.sku) >= 0;
                  return (
                    <ProductCard
                      model={model}
                      key={model.id}
                      onChange={handleCompareCheckboxChange}
                      selected={selected}
                      compareable={true}
                    />
                  );
                })}
              </section>
            </InfiniteScroll>
          </Col>
        </Row>
      </Container>
      <section>
        <ComparePanel
          selectedProducts={selectedProducts}
          onClear={handleClearSelectedProducts}
          onRemove={(sku) => handleUnSelectProduct(sku)}
        />
      </section>
    </>
  );
};

export default SearchPage;
